import React from "react";
import { getEndCustomerPaid } from "API/swesum";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

import { useNavigate } from "react-router-dom";
import EndCustomerPaidTable from "./components/EndCustomerPaidTable";
import { EndCustomerPaidContextProvider } from "Context/EndCustomerPaid";

export async function loader() {
  const invoices = await getEndCustomerPaid();
  return { invoices };
}

export function EndCustomerPaid() {
  const navigate = useNavigate();

  return (
    <EndCustomerPaidContextProvider>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Slutkundsinbetalningar</Typography>
              <Button
                onClick={() => navigate("create")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                SKAPA NY
              </Button>
            </Box>
            <EndCustomerPaidTable />
          </Grid>
        </Grid>
      </Box>
    </EndCustomerPaidContextProvider>
  );
}
